import e, { OPTIONS as T } from "../managers/braze-instance.js";
import ot from "../util/browser-detector.js";
import nr from "./l10n-manager.js";
const je = {
  t: !1,
  i: null,
  m: () => {
    if ((je.o(), !je.i)) {
      let r = ot.language,
        t = !1;
      e.nn(T.jn) && ((r = e.nn(T.jn)), (t = !0)), (je.i = new nr(r, t));
    }
    return je.i;
  },
  o: () => {
    je.t || (e.u(je), (je.t = !0));
  },
  destroy: () => {
    (je.i = null), (je.t = !1);
  }
};
export default je;
